import React from "react";

interface IconProps {
  isActive?: boolean;
}

const MeetingsIcon: React.FC<IconProps> = ({ isActive = false }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="w-[20px] h-[20px]"
  >
    <path
      d="M17.9741 18.75H4.44909M4.44909 18.75C4.02695 18.75 3.62211 18.5823 3.32361 18.2838C3.02511 17.9853 2.85742 17.5805 2.85742 17.1583M4.44909 18.75H15.5824V15.5667H17.1741V1.25H4.44909C4.02695 1.25 3.62211 1.41769 3.32361 1.71619C3.02511 2.01468 2.85742 2.41953 2.85742 2.84167V17.1583M2.85742 17.1583C2.85961 16.7369 3.02801 16.3333 3.32603 16.0353C3.62405 15.7373 4.02763 15.5689 4.44909 15.5667H17.9741M5.49915 4.75H14.9991M7.99915 8.25H12.2491M6.24915 11.75C8.24915 11.75 11.0825 11.75 12.2491 11.75H13.9991"
      stroke={isActive ? "#85BDFF" : "white"}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    ></path>
  </svg>
);

export default MeetingsIcon;
